import { schema } from 'normalizr';
import quizOption from './quizOption';

const quizSchema = new schema.Entity('quizes', {
  options: [quizOption],
});

export default quizSchema;
